export default {
  index: {
    title: 'QuantX Risk System'
  },
  route: {
    dashboard: 'Dashboard',
    icons: 'Icons',
    components: 'Components',
    componentIndex: 'Introduction',
    tinymce: 'Tinymce',
    markdown: 'Markdown',
    jsonEditor: 'JSON Editor',
    dndList: 'Dnd List',
    splitPane: 'SplitPane',
    avatarUpload: 'Avatar Upload',
    dropzone: 'Dropzone',
    sticky: 'Sticky',
    countTo: 'CountTo',
    componentMixin: 'Mixin',
    backToTop: 'BackToTop',
    dragDialog: 'Drag Dialog',
    dragKanban: 'Drag Kanban',
    charts: 'Charts',
    keyboardChart: 'Keyboard Chart',
    lineChart: 'Line Chart',
    mixChart: 'Mix Chart',
    errorPages: 'Error Pages',
    page401: '401',
    page404: '404',
    theme: 'Theme',
    clipboardDemo: 'Clipboard',
    i18n: 'I18n',
    profile: 'Profile',
    userManager: 'User manager',
    staffTable: 'Staff Table',
    customerTable: 'Customer table',
    systemManager: 'System Manager',
    codeManager: 'Code manager',
    gradeManager: 'Grade manager',
    gradeCardManager: 'Grade card manager',
    gradeMappingManager: 'Grade mapping manager',
    treeChart: 'GoJs',
    roleManager: 'Role manager',
    menuManager: 'Menu manager',
    decisionManager: 'Decision manager',
    riskFileManager: 'Risk file manager',
    decisionTreeView: 'Decision tree view',
    decisionTreeManager: 'Decision',
    testDecisionTreeManager: 'Test decision',
    decisionTreeRecordView: 'Decision tree record',
    decisionTreeVersionManager: 'Decision tree version manager',
    menuDataEdit: 'Menu data edit',
    blacklistManager: 'Blacklist manager',
    riskResultManager: 'Result manager',
    DataitemManager: 'DataItem manager',
    DataitemConfigView: 'DataItem config',
    TargetManager: 'Target manager',
    TargetConfigView: 'Target config',
    DyvarConfigView: 'Var config',
    blackManager: 'Blacklist Manager',
    blackInfoManager: 'Blacklist Manager',
    blackTypeManager: 'Blacklist Type Manager',
    orderManager: 'Order manager',
    merOrderInfoManager: 'Merchant order',
    merOrderGradeCardDetail: 'Merchant order detail',
    merOrderBlacklistDetail: 'Merchant order detail',
    integrate: 'integrate',
    system: 'system',
    business: 'business',
    cardVersionManager: 'Version manager',
    controlManager: 'Wind control switch',
    controlSetView: 'Switch setting',
    orderQueryView: 'Processing order',
    DeciRuleManager: 'Rule manager'
  },
  navbar: {
    logOut: 'Log Out',
    dashboard: 'Dashboard',
    screenfull: 'Screenfull',
    theme: 'Theme',
    size: 'Global Size',
    profile: 'Profile'
  },
  login: {
    title: 'Login Form',
    logIn: 'Log in',
    loginName: 'LoginName',
    password: 'Password',
    rules: {
      loginName_required: 'Please enter user name',
      password_required: 'Please enter password'
    }
  },
  // personal page
  profileInfo: {
    resetPass: {
      resetPassTitle: 'Reset Password',
      originalPassword: 'Original Password',
      currentPassword: 'New Password',
      passRule: 'At least 6 digits and must be composed of numbers and letters',
      passRuleConsistency: 'The old and new passwords cannot be the same'
    }
  },
  permission: {
    roles: 'Your roles',
    switchRoles: 'Switch roles'
  },
  tagsView: {
    refresh: 'Refresh',
    close: 'Close',
    closeOthers: 'Close Others',
    closeAll: 'Close All'
  },
  components: {
    SysCode: {
      defaultValue: 'Please select'
    }
  },
  table: {
    id: 'ID',
    type: 'Type',
    date: 'Date',
    status: 'Status',
    actions: 'Actions',
    search: 'Search',
    add: 'Add',
    export: 'Export',
    edit: 'Edit',
    delete: 'Delete',
    cancel: 'Cancel',
    confirm: 'Confirm',
    createdTime: 'Created time',
    lastModifiedTime: 'Last modified time',
    createdUser: 'Created user',
    lastModifiedUser: 'Last modified user',
    save: 'Save',
    import: 'Import',
    detail: 'Detail',
    view: 'View detail',
    publish: 'Publish',
    publish_test: 'Publish test',
    setting: 'Setting',
    submit: 'Submit',
    grant: 'Grant',
    batch: 'Batch',
    query: 'Query',
    reset: 'Rest',
    locked: 'Locked',
    unlocked: 'UnLocked',
    dyFilter: 'Filter',
    remark: 'Remark',
    refresh: 'Refresh',
    close: 'Close',
    show: 'Show',
    version: 'Version',
    keyPlaceholder: 'Input keyword',
    restPassword: 'Rest password',
    notNull: 'Must not null'
  },
  utils: {
    request: {
      opt_success: 'Successful operation!',
      logout_confirm_text: 'You have been logged out, you can cancel to stay on this page, or log in again!',
      logout_confirm_title: 'Confirm logout',
      logout_confirm_btn: 'Re sign up',
      logout_confirm_cancel: 'Cancel'
    },
    clipboard: {
      tips: 'Click to copy',
      success: 'Successful copy',
      error: 'Failed copy'
    }
  },
  views: {
    commons: {
      confirm: {
        remove_text: 'Confirm to delete this record?',
        ok: 'Confirm the operation?',
        cancel: 'Cancelled operation.'
      },
      message: {
        single_selected: 'Please select a data to operate.',
        multi_selected: 'Please select at least one data to operate.'
      },
      codes: {
        yes: 'Yes',
        no: 'No'
      }
    },
    system: {
      components: {
        menuSelect: {
          title: 'Menu authorization'
        },
        roleList: {
          title: 'Role selection',
          selectAll: 'Select all'
        },
        roleSelect: {
          title: 'Grant role',
          placeholder: 'Select role'
        }
      },
      menuManager: {
        filterH2: 'Menu list',
        filterPlaceholder: 'Enter keywords to filter',
        detailH2: 'Menu detail',
        addChild: 'Child menu',
        update: 'Update',
        form: {
          parentMenuId: 'Superior menu',
          menuCode: 'Menu code',
          menuName: 'Menu name',
          menuLevel: 'Menu level',
          remark: 'Remark'
        },
        rules: {
          menuName_required: 'Menu name is required.',
          menuCode_required: 'Menu code is required.'
        },
        append_text: 'Append',
        remove_text: 'Remove',
        message_formOpen_text: 'Please select the parent menu'
      },
      roleManager: {
        form: {
          roleName: 'Role name',
          roleCode: 'Role code',
          isUse: 'Enabled',
          remark: 'Remark'
        },
        rules: {
          roleName_required: 'Role name is required.',
          roleCode_required: 'Role code is required.'
        }
      },
      userManager: {
        form: {
          loginName: 'Login name',
          userName: 'User name',
          merNo: 'Merchant no',
          isUse: 'Enabled',
          password: 'Password',
          remark: 'Remark'
        },
        rules: {
          loginName_required: 'Login name is required.',
          userName_required: 'User name is required.',
          merNo_required: 'Merchant no is required.'
        }
      }
    },
    black: {
      blackInfoManager: {
        filter: {
          numberType: 'Please select the number type',
          number: 'Please enter the query number',
          typeKey: 'Please select the blacklist logo',
          typeName: 'Please enter the name of the blacklist type to be queried'
        },
        form: {
          numberType: 'Number Type',
          number: 'Number',
          numberTip: 'Please enter the blacklist number',
          typeKey: 'Blacklist type identification',
          remark: 'Remarks'
        },
        rules: {
          numberType_required: 'Please select the number type',
          number_required: 'Please enter the blacklist number',
          typeKey_required: 'Please select the blacklist type'
        },
        table: {
          numberType: 'Number Type',
          number: 'Number',
          typeKey: 'Blacklist type identification',
          typeName: 'Blacklist type name',
          joinTs: 'Into the black time',
          remark: 'Remarks'
        },
        confirm: {
          title: 'hint',
          content: 'Are you sure to delete this blacklist record? ',
          confirm: 'Confirm',
          cancel: 'cancel'
        }
      },
      blackTypeManager: {
        filter: {
          typeKey: 'Please enter the blacklist type identification',
          typeName: 'Please enter the name of the blacklist type'
        },
        form: {
          typeKey: 'Blacklist type identification',
          typeName: 'Blacklist type name',
          remark: 'Remarks'
        },
        rules: {
          typeKey_required: 'The blacklist type identifier cannot be empty',
          typeName_required: 'Blacklist type name cannot be empty'
        },
        confirm: {
          title: 'hint',
          content: 'Are you sure to delete this blacklist type record? The blacklist information corresponding to the deleted blacklist type will also be deleted in association! ',
          confirm: 'Confirm',
          cancel: 'cancel'
        }
      }
    },
    decision: {
      decisionTreeManager: {
        action: {
          versions: 'Versions'
        },
        formData: {
          treeNo: 'Tree no',
          treeName: 'Tree name',
          merNo: 'Merchant no',
          treeNoDefault: 'Default',
          firstNodeNo: 'First node no',
          treeId: 'Tree id'
        },
        rules: {
          treeNo_required: 'TreeNo required',
          treeNo_unique: 'TreeNo already exists',
          treeName_required: 'TreeName required'
        }
      },
      decisionTreeVersionManager: {
        action: {
          publish: 'Publish',
          publishRecords: 'Publish records',
          invalidRule: 'Clear invalid rules',
          records: 'Records'
        },
        dialog: {
          recordsList: 'Records',
          publishRecordsList: 'Publish records',
          invalidRuleList: 'Invalid rules'
        },
        formData: {
          versionNo: 'VersionNo',
          treeName: 'Tree name',
          title: 'Version name',
          running: 'Running',
          deciName: 'Rule name'
        },
        rules: {
          versionNo_required: 'VersionNo is required',
          title_required: 'VersionName is required'
        }
      },
      decisionTreeView: {
        action: {
          switchVersion: 'Switch version'
        },
        label: {
          runningVersion: 'Running',
          currentVersion: 'Current:',
          nodeInfo: 'Node info',
          ruleInfo: 'Rule info',
          addRule: 'Add rule',
          editRule: 'Edit rule',
          editRuleTips: 'Enter Ctrl automatic prompt',
          submitVersion: 'Save current version',
          viewMore: 'View more',
          infoTips: 'Please click to select the corresponding node and the rule will operate.',
          submitLoadingText: 'Data submission is being processed, please do not refresh the page',
          loadingText: 'loading....',
          exitTips: 'Do you have unsaved edits and are you sure to opt out?',
          openDeciRule: 'Click edit rule'
        },
        message: {
          success: 'Successful operation',
          fail: 'Operation failed',
          cancel: 'Cancelled operation',
          error: 'Please fill in the correct information',
          beforeClose: 'Are you sure you want to leave?',
          openSubmitFormDialog: 'Please select the first tree node first'
        },
        cacheMap: {
          node: 'Node',
          deci: 'Deci',
          added: 'Added',
          edited: 'Edited',
          removed: 'Removed'
        },
        formData: {
          id: 'ID',
          title: 'Version name',
          nodeName: 'Node name',
          targetIds: 'Target',
          deciName: 'Rule name',
          nodeId: 'NodeId',
          nextNodeId: 'Next nodeId',
          merNo: 'MerNo',
          treeId: 'TreeId',
          deciRule: 'Rule content',
          deciRuleType: 'Rule type',
          deciVal: 'Rule value',
          resultType: 'Result type',
          nodeLevel: 'Node level',
          anotherName: 'Another name',
          firstNodeId: 'First nodeId'
        },
        rules: {
          title_required: 'Version name is required',
          title_length: 'Please enter 10 characters or less',
          nodeName_required: 'Node name is required',
          nodeId_required: 'Node id is required',
          deciName_required: 'Rule name is required',
          deciVal_required: 'Rule value name is required',
          deciRuleType_required: 'Rule type name is required',
          resultType_required: 'Result type is required',
          nodeLevel_required: 'Node level is required',
          anotherName_required: 'Another name is required'
        }
      }
    },
    order: {
      merOrderInfoManager: {
        formData: {
          appNo: 'App no',
          orderNo: 'Order no',
          orderMerNo: 'OrderMerNo',
          prodNo: 'ProdNo',
          prodType: 'ProdType',
          prodMerNo: 'ProdMerNo',
          status: 'Status',
          uniqueKey: 'UniqueKey'
        },
        rules: {
          orderNo_required: 'OrderNo is required.'
        }
      },
      merOrderInfoDetail: {
        orderBasic: {
          title: 'Order info'
        },
        recordDiagram: {
          title: 'Risk track'
        },
        recordData: {
          title: 'Indicator data item',
          formData: {
            index: 'Index',
            name: 'Name',
            value: 'Value',
            status: 'status'
          }
        },
        chartOptions: {
          status_1: 'Pending',
          status_2: 'Processing',
          status_3: 'Processed',
          status_4: 'Failed'
        },
        orderInfo: {
          info: {
            appNo: 'App no',
            orderNo: 'orderNo',
            orderMerNo: 'orderMerNo',
            prodNo: 'prodNo',
            prodType: 'prodType',
            prodMerNo: 'prodMerNo',
            status: 'status',
            uniqueKey: 'uniqueKey'
          },
          result: {
            appNo: 'App no',
            orderMerNo: 'orderMerNo',
            prodNo: 'prodNo',
            orderNo: 'orderNo',
            prodType: 'prodType',
            prodMerNo: 'prodMerNo',
            status: 'status',
            uniqueKey: 'uniqueKey',
            orderResult: 'orderResult',
            noticeUrl: 'noticeUrl',
            noticeStatus: 'noticeStatus',
            expireTs: 'expireTs',
            compTs: 'compTs'
          }
        }
      },
      merOrderGradeCardDetail: {
        orderInfo: {
          title: 'Order Information',
          info: {
            appNo: 'App no',
            orderNo: 'Order number',
            orderMerNo: 'Order Merchant Number',
            prodNo: 'Product number',
            prodType: 'Product Type',
            prodMerNo: 'Attributable Merchant Number',
            status: 'Status',
            uniqueKey: 'Unique ID',
            remark: 'remarks'
          },
          result: {
            appNo: 'App no',
            orderNo: 'Order number',
            orderMerNo: 'Order Merchant Number',
            prodNo: 'Product number',
            prodType: 'Product Type',
            prodMerNo: 'Attributable Merchant Number',
            status: 'Status',
            uniqueKey: 'Unique ID',
            orderResult: 'Order Result',
            noticeUrl: 'Notification address',
            noticeStatus: 'Notification Status',
            expireTs: 'Product result expiration time',
            compTs: 'Order completion time',
            remark: 'remarks'
          }
        },
        recordGradeCard: {
          title: 'Score card information',
          info: {
            cardId: 'Score card number',
            cardName: 'Score card name',
            rule: 'Index sequence rule',
            sequence: 'Indicator sequence value',
            cardVal: 'Score value',
            status: 'Status',
            remark: 'remarks'
          }
        },
        recordTarget: {
          title: 'Associated Index Information',
          formData: {
            targetId: 'Indicator ID',
            targetName: 'Indicator name',
            targetVal: 'Indicator value',
            status: 'Status',
            etlId: 'ETLID',
            etlName: 'ETL name',
            etlType: 'ETL type',
            etlPath: 'ETL package path',
            mapping: 'Whether to map'
          }
        },
        recordData: {
          title: 'Indicator',
          formData: {
            index: 'Serial Number',
            name: 'Name',
            value: 'Indicator value',
            status: 'Status'
          }
        }
      },
      merOrderBlacklistDetail: {
        orderInfo: {
          title: 'Order Information',
          info: {
            appNo: 'App no',
            orderNo: 'Order number',
            orderMerNo: 'Order Merchant Number',
            prodNo: 'Product number',
            prodType: 'Product Type',
            prodMerNo: 'Attributable Merchant Number',
            status: 'Status',
            uniqueKey: 'Unique ID',
            remark: 'remarks'
          },
          result: {
            appNo: 'App no',
            orderNo: 'Order number',
            orderMerNo: 'Order Merchant Number',
            prodNo: 'Product number',
            prodType: 'Product Type',
            prodMerNo: 'Attributable Merchant Number',
            status: 'Status',
            uniqueKey: 'Unique ID',
            orderResult: 'Order Result',
            noticeUrl: 'Notification address',
            noticeStatus: 'Notification Status',
            expireTs: 'Product result expiration time',
            compTs: 'Order completion time',
            remark: 'remarks'
          }
        }
      }
    },
    grade: {
      gradeCardManager: {
        filter: {
          cardName: 'Please enter the name of the score card',
          rule: 'Index sequence rule'
        },
        form: {
          title: 'version name',
          versionNo: 'version number',
          publishStatus: 'Publish Status',
          cardName: 'Score card name',
          cardNameTips: 'Please enter the name of the score card',
          boundTitle: 'Bound index',
          unBoundTitle: 'Unbound indicator',
          ruleTitle: 'Index sequence rule:',
          tips1: 'Operation tips: click on the "unbound indicator" on the right to add it to the "list of bound indicators" on the left',
          tips2: 'Note: Please check whether the order of the indicator sequence rules is correct! (The list of bound indicators can be dragged to sort)',
          remark: 'Remarks',
          remarkTips: 'Fill in remarks information',
          boundTarget: 'Please select the associated target'
        },
        rules: {
          cardName_required: 'Score card name cannot be empty',
          title_required: 'Version name cannot be empty',
          title_limit_length: 'The length of the version name does not exceed 40',
          cardName_limit_length: 'The length of the score card name does not exceed 100',
          remark_limit_length: 'The length of the score card name does not exceed 200'
        },
        table: {
          cardId: 'Score card number',
          cardName: 'Score card name',
          rule: 'Index sequence rule',
          tipMapping: 'Mapping management'
        },
        confirm: {
          title: 'hint',
          content: 'Are you sure to delete this scorecard record? Deleting the score card and its corresponding mapping data will also be associated and deleted! ',
          confirm: 'Confirm',
          cancel: 'cancel'
        }
      },
      gradeMappingManager: {
        filter: {
          cardId: 'Please select a score card',
          val: 'Please enter the scorecard indicator mapping value',
          rule: 'Index sequence rule'
        },
        form: {
          cardId: 'Score Card',
          cardIdTips: 'Please select a score card',
          rule: 'Index sequence rule',
          sequence: 'Indicator sequence value',
          sequenceTips: 'Please enter the index sequence value (such as: 1, 2, 3)',
          val: 'mapped value',
          valTips: 'Please enter the scorecard index mapping value',
          remark: 'Remarks',
          remarkTips: 'Fill in remarks information',
          tips: 'Special reminder: Please carefully check whether the information is correct, and whether the indicator sequence rules and indicator sequence values ​​match? '
        },
        rules: {
          cardId: 'Please select a score card',
          sequence: 'Please enter the indicator sequence value',
          val: 'Please enter the scorecard indicator mapping value'
        },
        table: {
          upload: 'Batch Mapping Import',
          cardName: 'Score card name',
          rule: 'Index sequence rule',
          sequence: 'Indicator sequence value',
          val: 'mapped value'
        },
        upload: {
          title: 'Import of batch scoring card indicator mapping',
          buttonLabel: 'Mapping import',
          button: 'Select file',
          fileName: 'Batch scorecard mapping template.xlsx',
          download: 'Click to download the template',
          uploadTips: 'Only upload .xlsx/.xls files, and no more than 2M. ',
          tips1: 'Special tips:',
          tips2: 'When the scorecard mapping is imported in batches, all the mapping data under the scorecard will be cleared first, please confirm before importing! ',
          tips3: 'Please carefully confirm that the imported Excel file is the full scorecard mapping data of the scorecard! ',
          onExceed: 'Only one Excel file can be imported at the same time',
          excelRequired: 'Please select the Excel file that needs to be imported',
          excelSizeErr: 'The upload failed! The attachment size cannot exceed 2M',
          success: 'Scoring card batch mapping imported successfully',
          errorPrefix: 'Import failed:'
        },
        confirm: {
          title: 'hint',
          content: 'Are you sure you want to delete this scorecard mapping data? ',
          confirm: 'Confirm',
          cancel: 'cancel'
        }
      },
      commons: {
        dialog: {
          title: 'Details of indicator sequence rules',
          cardName: 'Score card name:',
          rule: 'Index sequence rule:'
        }
      }
    },
    merchant: {
      merchantInfoManager: {
        formData: {
          merNo: 'merNo',
          shortName: 'shortName',
          fullName: 'fullName',
          levelNo: 'levelNo',
          enable: 'enable',
          merKey: 'merKey',
          appNo: 'AppNo',
          prodNo: 'prodNo',
          noticeUrl: 'noticeUrl'
        },
        rules: {
          merNo_required: 'merNo_required',
          merNo_unique: 'merNo_unique',
          fullName_required: 'fullName_required',
          shortName_required: 'shortName_required',
          enable_required: 'enable_required',
          appNo_required: 'appNo_required',
          prodNo_required: 'prodNo_required',
          notify_required: 'notify_required',
          notify_invalid: 'Please enter the correct notification address'
        },
        action: {
          bindApp: 'bindApp',
          unBind: 'unBind',
          bindProd: 'bindProd'
        },
        dialog: {
          bindApp: 'bindApp',
          bindProd: 'bindProd'
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js